export const COLORS = ["#077a71", "#4858bb", "#d0671b"];
export const isScHlg = (host, bank, branch) => host === "sc-hlg.cidadeempreendedora.com.br" && bank === "ce-sc-hlg" && branch === "hlg";
export function formatValue(value) {
  return value === null || value === undefined ? "Sem histórico" : Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
}
export function position(index, total, value, radius = 155) {
  const angle = -Math.PI / 2 + index * 2 * Math.PI / Math.max(total, 1);
  return { x: 320 + Math.cos(angle) * radius * value / 100, y: 240 + Math.sin(angle) * radius * value / 100 };
}
export function polygon(total, value) {
  return Array.from({ length: total }, (_, i) => position(i, total, value)).map(p => `${p.x},${p.y}`).join(" ");
}
// Null values produce gaps and never draw points at the origin.
export function segments(points, cut) {
  if (!points.length) return [];
  const values = points.map(p => p.valores[cut]);
  if (values.every(v => v !== null && v !== undefined)) return [polygonValues(values.concat(values[0]), points.length)];
  const result = [];
  for (let i = 0; i < points.length; i++) {
    const next = (i + 1) % points.length;
    if (values[i] == null || values[next] == null) continue;
    const a = position(i, points.length, values[i]); const b = position(next, points.length, values[next]);
    result.push(`${a.x},${a.y} ${b.x},${b.y}`);
  }
  return result;
}
function polygonValues(values, total) {
  return values.map((value, i) => position(i % total, total, value)).map(p => `${p.x},${p.y}`).join(" ");
}
export function wrapLabel(text, max = 23) {
  const lines = [""];
  String(text).split(/\s+/).forEach(word => { const last = lines.length - 1; if (lines[last] && (lines[last] + " " + word).length > max) lines.push(word); else lines[last] += (lines[last] ? " " : "") + word; });
  return lines;
}
export function validateDates(dates) {
  if (dates.length !== 3 || dates.some(d => !/^\d{4}-\d{2}-\d{2}$/.test(d) || Number.isNaN(Date.parse(d)) || new Date(d).toISOString().slice(0, 10) !== d)) return "Informe três datas válidas.";
  return dates[0] > dates[1] || dates[1] > dates[2] ? "Use T0 ≤ T1 ≤ T2." : "";
}
